import $ from 'jquery';
import TextBundleUtil from '@lts-web/utils/TextBundleUtil';

$.TextBundleUtil = TextBundleUtil;